import {User} from "./user";

export enum DirectoryStatus{
  ARCHIVED = 0,
  ACTIVE = 1
}

export interface Directory{
  id: number,
  name: string,
  description: string,
  sortindex: number,
  status: DirectoryStatus,
  created_at?: number|Date,
  created_by?: string|User,
  updated_at?: number|Date,
  archived_at?: number|Date,
  archived_by?: string|User
}
